import React, { type FC } from "react";
import { useTrackElement } from "@edreamsodigeo/frontend-core";
import { ButtonWithLoading } from "@edreamsodigeo/prisma-design-system";

import { type SubmitButtonProps } from "./contract";

export const submitButtonId = "passwordless-submit-button-id";

const SubmitButton: FC<SubmitButtonProps> = ({
  onClick,
  label,
  trackingId,
  loading,
}) => {
  const clickTrackingRef = useTrackElement<HTMLButtonElement>(
    ["click"],
    trackingId,
  );

  return (
    <ButtonWithLoading
      id={submitButtonId}
      ref={clickTrackingRef}
      fullWidth
      disabled={loading}
      loading={loading}
      onClick={onClick}
    >
      {label}
    </ButtonWithLoading>
  );
};

export default SubmitButton;
